const o = (t) => {
  const r = /(.*)(\..*)$/.exec(t);
  return r && r.shift(), r || [];
}, c = (t, n) => {
  if (t.length < n)
    return t;
  const r = o(t);
  if (!r)
    return t;
  const e = r[0] || "", s = r[1] || "";
  return e ? e.substr(0, n / 2) + "…" + e.substr(e.length - n / 2) + s : t;
};
export {
  c as truncateFileName
};
//# sourceMappingURL=HoopsViewerName.utils.mjs.map
